import { render } from "./ActivityDetails.page.vue?vue&type=template&id=016c8c8a&scoped=true&ts=true"
import script from "./ActivityDetails.page.vue?vue&type=script&lang=ts"
export * from "./ActivityDetails.page.vue?vue&type=script&lang=ts"

import "./ActivityDetails.page.vue?vue&type=style&index=0&id=016c8c8a&lang=scss&scoped=true"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016c8c8a"]])

export default __exports__